// Breakpoints
export var BREAKPOINT_DOWN_SMALL = "(max-width: 767px)";
export var BREAKPOINT_UP_MEDIUM = "(min-width: 1025px)";
export var BREAKPOINT_DOWN_MEDIUM = "(max-width: 1024px)";

export var BACKEND_ROOT = void 0;
export var FRONTEND_ROOT = void 0;

export var IS_PROD = ["production", "staging"].includes(process.env.ENV);

switch (process.env.ENV) {
  case "production":
    BACKEND_ROOT = "https://api.axios.com";
    FRONTEND_ROOT = "https://www.axios.com";
    break;
  case "staging":
    BACKEND_ROOT = "https://api-stage.axios.com";
    FRONTEND_ROOT = "https://firstorder-stage.axios.com";
    break;
  default:
    BACKEND_ROOT = "http://localhost:8000";
    FRONTEND_ROOT = "http://localhost:3006";
    break;
}

export var API_ROOT = BACKEND_ROOT + "/api/render/";

export var EVENTS_API = "https://eventsdata.axios.com/upcoming-events.json";

// Draft js
export var BLOCK_TYPE = {
  EMBED: "embed",
  KEEP_READING: "keep-reading",
  QUOTE_ATTRIBUTION: "quote-attribution",
  STYLED_QUOTE: "styled-quote"
};

export var STYLE_TYPE = {
  BOLD: "bold",
  ITALIC: "italic"
};

export var ENTITY_TYPE = {
  LINK: "link"
};

export var GA_KEY = process.env.ENV === "production" ? "UA-87586659-1" : "UA-87586659-3";

export var GA_TRACKED_LINK_TYPE = {
  SAVE: "save",
  LINK: "links",
  READ_MORE: "readmore",
  READ_ANOTHER: "readanother",
  SS_CL: "socialshare_cl",
  SS_FB: "socialshare_fb",
  SS_TW: "socialshare_tw",
  SS_LI: "socialshare_li"
};

export var URL_ID_REGEXP = "([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|[0-9]+)";

// "Musical Meerkat" key - the default key's secret component was exposed to GitHub
export var RAVEN_DSN = "https://1b87f5b715e44d8496741fe423b7c3de@sentry.io/247977";

export var FACTS_MATTER_TEMPLATE = "00000000-0000-0000-0003-000000000001";

export var FB_JS_SDK_VERSION = "2.12";


// WEBPACK FOOTER //
// ./src/config/constants.js